import FormVM from './form-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init(node) {
    const data = JSON.parse($('#js-coupon-campaigns').val());
    const couponData = JSON.parse($('#js-coupon').val());
    const vm = new Vue(FormVM);
    vm.bindData({campaign: data, coupon: couponData});
    vm.$mount(node);
  }
};
